"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOSTBGMoff = void 0;
const mobx_1 = require("mobx");
const DOBaseScriptStatement_1 = require("../DOBaseScriptStatement");
class DOSTBGMoff extends DOBaseScriptStatement_1.DOBaseScriptStatement {
    constructor(data, block, uniqueId) {
        super(data, block, uniqueId);
        (0, mobx_1.makeObservable)(this, {
        //
        });
    }
    get st() {
        return this.data;
    }
    generateSheetColumnsAfterBackground() {
        if (!!this.executeConditionOfStatement) {
            return ['', '', '', '', '', '', '', this.executeConditionOfStatement];
        }
        return [];
    }
    //
    // IStudioTranslator interface
    //
    async getMessagesToTranslate() {
        return null;
    }
}
exports.DOSTBGMoff = DOSTBGMoff;
